import { CountryInformationStyle } from '../../styles/components/country';

export interface ICountryInformationProps {
  subTitle?: string;
  title?: string;
  pageInformation: any;
}

const CountryInformation = (props: ICountryInformationProps) => {
  return (
    <div className={CountryInformationStyle.CountryInformation}>
      {props.pageInformation}
    </div>
  );
};

export default CountryInformation;
